import React from "react";
import img_1 from "../images/img_1.png";
import img_2 from "../images/img_2.png";
import img_3 from "../images/img_3.png";


const Home = () => {
  return (
    <div className="main-home">
      <div className="home">
        <div className="home-text">
          <div className="home-text-heading">
            <h1 className="home-text-1">Embark on a Journey to</h1>
            <h1 className="home-text-2">Revitalize Your Being</h1>
            <h1 className="home-text-3">
              <span>@ Atharv Ayurved</span>
            </h1>
          </div>
          <div className="home-text-sub-text">
            Unveiling the secrets of well-being through the perfect synergy of
            ancient Ayurvedic wisdom and modern medical expertise.
          </div>

          <div className="home-text-btns">
            <button className="btn">Schedule Your Ayurvedic Session</button>
            <a href="#">Explore Our Ayurvedic Services</a>
          </div>
        </div>

        <div className="home-img">
          <img src={img_1} alt="ATHARV Home" />
        </div>
      </div>
      
      <div className="home-1">
        <div className="home-heading-1">
          <h1>Unleash the Power of Ayurveda</h1>
          <h1>at ATHARV Multispeciality Clinic</h1>
        </div>
        <div className="home-content-1">
          <div className="home-1-img">
            <img src={img_2} alt="Community Health Centers" />
          </div>
          <div className="home-1-text">
            <h1 className="home-1-text-1">Awaken Your Wellness Journey</h1>
            <h1 className="home-1-text-2">with Ayurvedic Excellence</h1>
            <div className="home-text-sub-text text-1">
              Immerse yourself in the natural healing force within, guided by the
              expertise of ATHARV Ayurveda.
            </div>
            <div className="home-text-btns">
              <button className="btn">Book Your Ayurvedic Retreat</button>
            </div>
          </div>
        </div>

        <div className="home-content-1">
          <div className="home-1-text">
            <h1 className="home-1-text-1">Your Well-being,</h1>
            <h1 className="home-1-text-2">Our Passionate Pursuit</h1>
            <div className="home-text-sub-text text-1">
              Experience a personalized path to health as we guide you with
              Ayurvedic wisdom and compassionate care.
            </div>
            <div className="home-text-btns">
              <button className="btn">Start Your Healing Journey</button>
            </div>
          </div>
          <div className="home-1-img img-2">
            <img src={img_3} alt="Ayurvedic Consultation" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
